// /utils/masks.js

export const maskCEP = (value = "") =>
  value
    .replace(/\D/g, "")
    .replace(/(\d{5})(\d)/, "$1-$2")
    .substring(0, 9);

export const maskPhone = (value = "") =>
  value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d{4})$/, "$1-$2")
    .substring(0, 15);

export const maskEmail = (value = "") => value.toLowerCase().trim();

export const maskNumber = (value = "") =>
  value.replace(/\D/g, "");

export const maskName = (value = "") =>
  value.replace(/[^A-Za-zÀ-ú\s]/g, "");

export const maskCPF = (value = "") =>
  value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{2})$/, "$1-$2")
    .substring(0, 14);

export const maskCNPJ = (value = "") =>
  value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{2})$/, "$1-$2")
    .substring(0, 18);
